module.exports = __webpack_public_path__ + "img/appAsset-brand--defontana.a1ccb4ff.svg";